import * as channels from './channels';

export const facebook = {
  ...channels,
};
